/* eslint-disable @next/next/no-img-element */
const Preloader = () => {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <img src="/assets/icons/logo.svg" alt="logo" className='animate-bounce' />
    </div>
  )
}

export default Preloader;